/**
 * Resolves the platform .NET API base URL (no trailing slash) from the current page.
 *
 * Rules:
 * - Optional REACT_APP_PLATFORM_API_URL: override when inference is not enough (bare IP host, unusual domains).
 * - localhost / 127.0.0.1: env override or http://localhost:5000 in development.
 * - Already on api.*: same origin.
 * - Otherwise: protocol + "//api." + base host (amglobal.co → api.amglobal.co, www.amglobal.dev → api.amglobal.dev).
 */
function baseHost(hostname) {
  const withoutWww = hostname.replace(/^www\./i, "");
  const parts = withoutWww.split(".").filter(Boolean);
  if (parts.length <= 2) {
    return withoutWww;
  }
  return parts.slice(-2).join(".");
}

const defaultLocalApi = "http://localhost:5000";

export function getPlatformApiBaseUrl() {
  if (typeof window !== "undefined") {
    const { protocol, hostname, port } = window.location;

    if (hostname) {
      if (hostname === "localhost" || hostname === "127.0.0.1") {
        const fromEnv = (process.env.REACT_APP_PLATFORM_API_URL || "").trim().replace(/\/+$/, "");
        if (fromEnv) {
          return fromEnv;
        }
        if (process.env.NODE_ENV === "development") {
          return defaultLocalApi;
        }
        return defaultLocalApi;
      }

      if (/^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)) {
        const fromEnv = (process.env.REACT_APP_PLATFORM_API_URL || "").trim().replace(/\/+$/, "");
        return fromEnv;
      }

      if (/^api\./i.test(hostname)) {
        const portSuffix = port ? `:${port}` : "";
        return `${protocol}//${hostname}${portSuffix}`.replace(/\/+$/, "");
      }

      const base = baseHost(hostname);
      return `${protocol}//api.${base}`.replace(/\/+$/, "");
    }
  }

  const fromEnv = (process.env.REACT_APP_PLATFORM_API_URL || "").trim().replace(/\/+$/, "");
  if (fromEnv) {
    return fromEnv;
  }
  if (process.env.NODE_ENV === "development") {
    return defaultLocalApi;
  }
  return "";
}
